export const UPDATE_ORDER_ATTEMPT_LIST = "update-order-attempt-listing"
export const REMOVE_ORDER_ATTEMPT = "remove-order-attempt"


// WEBPACK FOOTER //
// ./src/state/price-list/orderAttemptActionTypes.ts